import React, { useContext } from 'react';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Image } from '../../elements/image';
import { useNavigate } from 'react-router-dom';
import { images } from '../../constants/images';
import { Text } from '../../elements/text';
import { useTranslation } from 'react-i18next';
import { MenuDetails, Status, StoreWithDetails } from '../../types/vendor-menu';
import { AppContext } from '../../context/app-context';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import { TEXT_STYLES } from '../../theme';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);
interface MenuCardProps {
  menu: MenuDetails;
  store: StoreWithDetails;
  vendorID: string;
  storeID: string;
  status?: Status;
}

export function StoreMenuCard({ store, menu, status }: MenuCardProps) {
  const { t } = useTranslation(['patron_portal']);
  const navigate = useNavigate();
  const { selectedMenuId } = useContext(AppContext);

  return (
    <Box
      onClick={() => {
        if (status !== Status.InActive && store.isOpen) {
          selectedMenuId?.setValue(menu.menu.id);
          navigate(
            `/vendors/${store.ownerID}/stores/${store._id}/menu/${menu.menu.id}`,
          );
        }
      }}
    >
      <Image
        style={{
          height: '200px',
          width: '100%',
          objectFit: 'cover',
          borderRadius: '12px',
          filter:
            status === Status.InActive || !store.isOpen
              ? 'grayscale(100%)'
              : 'grayscale(0%)',
        }}
        src={
          menu.menu.imageUri ||
          store.storeFrontImageUrl ||
          store.owner.imageUrl ||
          images.VENDOR_DEFAULT_IMAGE
        }
      />
      <Box
        display={'flex'}
        flexDirection={'row'}
        justifyContent={'space-between'}
        alignItems={'flex-start'}
      >
        <Box mt={1.5}>
          <Typography fontSize={16} fontWeight={500}>
            {`${store.displayName} — ${menu.menu.description}`}
          </Typography>
          {menu?.schedule?.isScheduled ? (
            <Typography fontSize={14} fontWeight={500}>
              ({dayjs(menu.schedule.time[0], 'HH:mm').format('hh:mm A')} -{' '}
              {dayjs(menu.schedule.time[1], 'HH:mm').format('hh:mm A')})
            </Typography>
          ) : (
            <>
              <Typography sx={TEXT_STYLES.allDayLabel}>(All Day)</Typography>
              <Typography sx={TEXT_STYLES.discountLabel}>
                {menu?.menu?.discounts?.[0]?.discountAmount &&
                  `(${menu.menu.discounts[0].discountAmount}${t(
                    'patron_portal.menu.label.discountText',
                  )})`}
              </Typography>
            </>
          )}

          {status === Status.InActive || !store.isOpen ? (
            <Typography sx={TEXT_STYLES.unavailableLabel}>
              {t('patron_portal.vendor.currentlyUnavailable', {
                ns: 'patron_portal',
              })}
            </Typography>
          ) : null}
          <Box mt={1.5}></Box>
        </Box>
        {menu?.schedule?.isScheduled && (
          <Box
            mt={1.5}
            width={'50px'}
            height={'50px'}
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <EventAvailableIcon />
          </Box>
        )}
      </Box>
    </Box>
  );
}
